<script>
let customerId = window.localStorage.getItem("customerId");
import baseList from "@/views/components/base/baseList.vue";
import { IMAGE_HOST } from "../../config";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "fileDownloadList",
        url: {
          list: "/admin/system/resourceDownload/listNoA?delStatus=1",
        },
      },
      actions: [
        {
          label: "返回登录",
          type: "info",
          onClick: this.toBack,
        },
      ],

      filters: [
        {
          label: "适用型号",
          name: "content",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "名称",
          name: "name",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: "名称",
          minWidth: 200,
          align: "left",
          key: "name",
        },
        {
          title: "备注",
          minWidth: 200,
          align: "left",
          key: "content",
        },
        // {
        //   title: "备注",
        //   width: 180,
        //   align: "left",
        //   key: "remark",
        // },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.downloadFile(currentRow.path)}
                  type="default"
                  style={{
                    border: "none",
                    marginRight: "5px",
                    color: "#4991ff",
                  }}
                >
                  下载
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.query.delStatus = 1
  },
  methods: {
    downloadFile(text) {
      const texturl = text.split(",");
      /* for (let i = 0; i < texturl.length; i++) {
        texturl[i] = IMAGE_HOST + texturl[i];
      } */
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `下载附件`,
        width: "600px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <List border size="small">
                {files.map((item) => {
                  return (
                    <ListItem>
                      <p
                        style="color:#4991ff; cursor: pointer;"
                        onClick={() => window.open(IMAGE_HOST + item.url, "_self")}
                      >
                        {item.name}
                      </p>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          );
        },
      });
    },
    /*  downloadFile(row) {
       if (!row.path) {
         $utils.toast.error("暂无文件！");
       } else {
         window.open(IMAGE_HOST + row.path, "_self");
       }
     }, */
    toBack() {
      $utils.url.go(-1);
    },
  },
};
</script>
<style scoped></style>
